import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
// Async Thunk for fetching Sub Categories based on Main Category ID
export const fetchSubCategories = createAsyncThunk(
    "category/fetchSubCategories",
    async ({mainCategoryId ,  language}, { rejectWithValue }) => {      
      try {
        const response = await axiosInstance.post(
          "/api/Admin/GetSubCategories",
          { mainCategoryFk: mainCategoryId },
          {
            headers: {
              "Content-Type": "application/json-patch+json",
              "lang": language === "English" ? "2" : "1",
            },
          }
        );  
        // Parse the message field from the response before returning it
        const data = JSON.parse(response.data.message); // Parse the string to an object
        return data.Data; // Return the subcategories data array
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        return rejectWithValue(error.response?.data || "Error fetching subcategories");
      }
    }
  );
  

// SubCategory slice
const subCategorySlice = createSlice({
  name: "subCategory",
  initialState: {
    subCategories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.subCategories = payload;
      })
      .addCase(fetchSubCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subCategorySlice.reducer;
